import React, { useState } from "react";
import "./index.css"
import ArrowRight from "../../assets/arrow-right.svg"
import { dataService } from "../../components/contents_data/index"
export const Services = () => {

    return (
        <div className="container-art">
            <div className="container-art-1 mt-5">
                <div className="d-flex justify-content-center align-item-center">
                    <div className="lead-sub">Services</div>
                </div>
                <div className="d-flex justify-content-end pt-3">
                    <small className="primary">View All <img src={ArrowRight} /></small>

                </div>
                <br />
                <div className="row">
                    {dataService?.map((d, index) => (
                        <div className="col-6 col-md-4 col-lg-2 mb-3" key={index}>
                            <div className="service-borders">
                                <div className="text-center">
                                    <div>
                                        <div>
                                            <img src={d?.img} />
                                        </div>
                                        <div>{d?.name}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>

    );
};

